"use strict";
(function () {
  if (!customElements.get("product-reviews")) {
    class ProductReviews extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
        this.slider = this.querySelector(".swiper");
      }

      connectedCallback() {
        this.initSwiper();
      }
    }

    ProductReviews.prototype.initSwiper = function () {
      if (!this.slider) return;

      const speed = Number(this.slider.dataset.speed) || 500;
      const changeSpeed = Number(this.slider.dataset.changeSpeed) || 5000;
      const rotate = this.slider.dataset.rotate === "true";
      const swiperOptions = {
        loop: true,
        slidesPerView: 1.1,
        spaceBetween: 8,
        grabCursor: true,
        longSwipesRatio: 0.3,
        autoHeight: true,
        fadeEffect: {
          crossFade: true,
        },
        speed,
        pagination: {
          el: ".product-reviews-pagination-wrapper .swiper-pagination-bullets",
          clickable: false,
        },
        
        breakpoints: {
          767: {
            slidesPerView: 2,
            spaceBetween: 30,
          }
        },
      };

      if (rotate) {
        swiperOptions.autoplay = {
          delay: changeSpeed,
        };
      }

      this.swiper = new Swiper(this.slider, swiperOptions);

    };

    customElements.define("product-reviews", ProductReviews);
  }
})();
